<div class="auth-wrapper">
  <img
    class="logo tui-space_bottom-8"
    #img
    [class.logo--loaded]="img.customLoaded"
    (load)="img.customLoaded = true"
    src="https://res.cloudinary.com/aitarget/image/upload/v1622046861/ai-tech-logo/login-logo-gif.gif"
  />
  <form
    class="auth-form"
    #ngForm="ngForm"
    *ngIf="currentFormName === 'login'"
    [formGroup]="loginForm"
    (ngSubmit)="login()"
  >
    <span class="ait-font-text-m tui-space_bottom-4 ait-text-align-center ait-white-space-pre-wrap">
      {{ '👋 Welcome! Please log in to Aitarget Tech' | translate }}
    </span>

    <div class="ait-fullwidth tui-space_bottom-4">
      <tui-input [tuiTextfieldLabelOutside]="true" tuiTextfieldSize="m" formControlName="username">
        {{ 'Email' | translate }}
        <input [attr.autocomplete]="autocompleteUsername" tuiTextfield />
      </tui-input>
      <!--Validation-->
      <ng-container *ngIf="loginForm.get('username').touched">
        <tui-error
          *ngIf="loginForm.get('username').errors?.required"
          [error]="errorUsernameRequired$ | async"
        ></tui-error>
        <tui-error
          *ngIf="loginForm.get('username').errors?.maxlength"
          [error]="errorUsernameMaxLength$ | async"
        >
        </tui-error>
        <tui-error
          *ngIf="loginForm.get('username').errors?.email"
          [error]="errorUsernameEmail$ | async"
        >
        </tui-error>
      </ng-container>
      <!--Validation-->
    </div>

    <div class="ait-fullwidth tui-space_bottom-4">
      <tui-input-password
        [tuiTextfieldLabelOutside]="true"
        tuiTextfieldSize="m"
        formControlName="password"
      >
        {{ 'Password' | translate }}
        <input [attr.autocomplete]="autocompleteCurrentPassword" tuiTextfield />
      </tui-input-password>
      <!--Validation-->
      <ng-container *ngIf="loginForm.get('password').touched">
        <tui-error
          *ngIf="loginForm.get('password').errors?.required"
          [error]="errorPasswordRequired$ | async"
        ></tui-error>
        <tui-error
          *ngIf="loginForm.get('password').errors?.maxlength"
          [error]="errorPasswordMaxLength$ | async"
        >
        </tui-error>
      </ng-container>
      <!--Validation-->
    </div>

    <div class="tui-space_bottom-4" *ngIf="isCaptchaRequired$ | async">
      <re-captcha
        class="recaptcha"
        [siteKey]="env.google_recaptcha_site_key"
        [theme]="!(appStateService.isNightTheme$ | async) ? 'light' : 'dark'"
        formControlName="captcha"
      ></re-captcha>
      <!--Validation-->
      <ng-container *ngIf="loginForm.get('captcha').touched">
        <tui-error
          *ngIf="loginForm.get('captcha').errors?.required"
          [error]="errorCaptchaRequired$ | async"
        ></tui-error>
      </ng-container>
      <!--Validation-->
    </div>

    <a class="tui-space_bottom-4" [pseudo]="true" (click)="changeTab('reset')" tuiLink>{{
      'Forgot password?' | translate
    }}</a>

    <button
      class="ait-fullwidth tui-space_bottom-2"
      [showLoader]="isAuthenticating$ | async"
      [disabled]="isAuthenticatingFacebook$ | async"
      (click)="login()"
      data-gtm-id="login_login"
      tuiButton
      size="l"
      appearance="auth"
      type="submit"
      iconRight="tuiIconLoginLarge"
    >
      {{ 'Login' | translate }}
    </button>
  </form>

  <ng-container *ngIf="currentFormName === 'login'">
    <p class="text-center tui-space_bottom-2">{{ 'or' | translate }}</p>
    <button
      class="ait-fullwidth tui-space_bottom-4"
      [showLoader]="isAuthenticatingFacebook$ | async"
      [disabled]="isAuthenticating$ | async"
      (click)="loginWithFacebook()"
      data-gtm-id="login_login_via_fb"
      tuiButton
      size="l"
      appearance="auth-fb"
      icon="https://res.cloudinary.com/aitarget/image/upload/v1616492440/platforms/facebook.svg"
    >
      {{ 'Log in with Facebook' | translate }}
    </button>
  </ng-container>

  <form
    class="auth-form"
    #ngForm="ngForm"
    *ngIf="currentFormName === 'reset'"
    [formGroup]="resetForm"
    (ngSubmit)="reset()"
  >
    <span class="ait-font-text-m tui-space_bottom-4 ait-text-align-center ait-white-space-pre-wrap">
      {{ '☝🏻 Please enter your email to get password recovery link' | translate }}</span
    >

    <div class="ait-fullwidth tui-space_bottom-4">
      <tui-input [tuiTextfieldLabelOutside]="true" tuiTextfieldSize="m" formControlName="username">
        {{ 'Email' | translate }}
        <input [attr.autocomplete]="autocompleteUsername" tuiTextfield />
      </tui-input>
      <!--Validation-->
      <ng-container *ngIf="resetForm.get('username').touched">
        <tui-error
          *ngIf="resetForm.get('username').errors?.required"
          [error]="errorUsernameRequired$ | async"
        ></tui-error>
        <tui-error
          *ngIf="resetForm.get('username').errors?.maxlength"
          [error]="errorUsernameMaxLength$ | async"
        >
        </tui-error>
        <tui-error
          *ngIf="resetForm.get('username').errors?.email"
          [error]="errorUsernameEmail$ | async"
        >
        </tui-error>
      </ng-container>
      <!--Validation-->
    </div>

    <div class="tui-space_bottom-4">
      <re-captcha
        class="recaptcha"
        [siteKey]="env.google_recaptcha_site_key"
        formControlName="captcha"
        theme="light"
      ></re-captcha>
      <!--Validation-->
      <ng-container *ngIf="resetForm.get('captcha').touched">
        <tui-error
          *ngIf="resetForm.get('captcha').errors?.required"
          [error]="errorCaptchaRequired$ | async"
        ></tui-error>
      </ng-container>
      <!--Validation-->
    </div>

    <a class="tui-space_bottom-4" [pseudo]="true" (click)="changeTab('login')" tuiLink>
      {{ 'Remember your password?' | translate }}
    </a>

    <button
      class="ait-fullwidth tui-space_bottom-4"
      [showLoader]="isAuthenticating$ | async"
      (click)="reset()"
      tuiButton
      size="m"
      appearance="auth"
      type="submit"
    >
      {{ 'Send me recovery link' | translate }}
    </button>
  </form>

  <p class="ait-text-align-center" *ngIf="currentFormName === 'confirm'">
    {{ '👌 If you email is correct, we send the reset password link' | translate }}
  </p>

  <p class="text-center">
    {{ 'Don’t have an account?' | translate }}
    <a tuiLink routerLink="/signup">{{ 'Sign up' | translate }}</a>
  </p>

  <tui-toggle
    class="special-toggle tui-space_top-2"
    *ngIf="isLangChangeShown$ | async"
    [ngModel]="!localeService.isEngLocale()"
    (ngModelChange)="localeService.switchLocale()"
    appLocaleToggle
  ></tui-toggle>

  <div class="tui-space_top-12">
    <p class="text-center ait-font-additional-color ait-font-text-s tui-space_bottom-1">
      {{ 'AITARGET INC.' | translate }}
    </p>

    <p class="text-center ait-font-additional-color ait-font-text-s">
      {{ '54 W 40th St New York, 10018' | translate }}
    </p>
  </div>

  <!--Backend Errors-->
  <ng-container *ngIf="backendError$ | async as backendError">
    <tui-error class="text-center special-error" [error]="getError(backendError)"></tui-error>
  </ng-container>
  <!--Backend Errors-->
</div>
